module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO17QueEsPresupuesto (48).376453d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO17QueEsPresupuesto (48).mp4
// module id = 743
// module chunks = 1